export const LANGUAGE_VERSIONS = {
  java: "15.0.2",
  javascript: "18.15.0",
  cpp: "10.2.0",
  python: "3.10.0",
  sql: "1.0.0",
};

export const CODE_SNIPPETS = {
  java: ``,
  javascript: ``,
  cpp: ``,
  python: ``,
  sql: ``,
};
